/**
 * Action creator for the allowed-surveys multi-select picker used
 * in AccountEdit's Features section. Served from the top-level
 * `/surveys` endpoint (not scoped to an account) — same as legacy.
 *
 * Endpoint: GET /surveys
 */
export const fetchSurveysAction = () => ({
  method: 'GET',
  endpoint: '/surveys',
});
